export default __webpack_public_path__ + "static/media/document.861f7c28.svg";